import React from 'react';

export default function Logger(step) {
	fetch('/api/log-step', {
  		method: 'POST',
  		headers: { 'Content-Type': 'application/json' },
  		body: JSON.stringify({ step: step })
	});
}